import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';

import { HelpBoxBadgeComponent } from './help-box-badge.component';
import { HelpBoxModel } from './models';

@Component({
    selector: 'ms-help-box',
    templateUrl: './help-box.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, TrustPipe, HelpBoxBadgeComponent],
})
export class HelpBoxComponent {
    readonly epcotConfig = inject(EpcotConfig);
    readonly sitecore = inject(Sitecore);

    readonly data = input.required<HelpBoxModel>();
    readonly disableInfoIcon = input(false);

    readonly closeButtonClick = output();
    readonly infoIconClick = output();

    get isEpcot(): boolean {
        return this.epcotConfig.isEnabled;
    }
}
